import CustomButton from "../../../component/elements/CustomButton/CustomButton";
import CloseIcon from "@mui/icons-material/Close";
import axiosInstance from "../../../configuration/request";
import { useSnackbar } from "../../../component/SnackbarContext";

function PaymentConfirmation({ onClose , onSubmit ,dialogDetails}) {
  const showSnackbar = useSnackbar();
  const handleSubmit = async () => {

      axiosInstance
      .post(`/payment/retrigger/${dialogDetails?.id}`)
      .then((res) => {
        showSnackbar("Payment Successful", "success");
        onSubmit()
      })
      .catch((error) => {
        showSnackbar(
          error?.response?.data?.message || "Something went wrong!",
          "error"
        );
      });

  };
  

  return (
    <div className="pt-6 px-6">
      <div className="flex justify-between mb-6">
        <div className="text-base xs:text-lg font-[500]">Payment Confirmation</div>
        <button
          className="hidden xs:block text-gray-600 hover:text-black"
          onClick={onClose}
          aria-label="Close"
        >
          <CloseIcon />
        </button>
      </div>
                 <div className="text-center text-gray-700 text-xs xs:text-sm sm:text-base font-medium">
      Are you sure you want to proceed with this payment?  
      Once confirmed, the amount will be deducted and the transaction will be recorded.
    </div>

        <div className="flex flex-col xs:flex-row  justify-center items-center my-8 gap-3">
              <CustomButton
            onClick={onClose}
              customeClass='primary-custom-button w-full xs:w-[150px] h-[40px]'
          >
            Cancel
          </CustomButton>
       
          <CustomButton
            onClick={handleSubmit}
              customeClass='gradient-button w-full xs:w-[150px] h-[40px]'
          >
            Pay Now
          </CustomButton>
        </div>
    </div>
  );
}

export default PaymentConfirmation;
